import * as Yup from "yup";

export const PriceSchema = Yup.object().shape({
    sku: Yup.string().required("Пожалуйста, укажите артикул"),
    rrc_price: Yup.number().required("Пожалуйста, укажите розничную цену"),
    sale_price: Yup.number().required("Пожалуйста, укажите цену продажи"),
    discount_percent: Yup.number().nullable(),
    price_with_discount: Yup.number().nullable(),
});
